import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=51a52ce0&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
import style0 from "./Channel.vue?vue&type=style&index=0&id=51a52ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a52ce0",
  null
  
)

export default component.exports